/** @jsxRuntime classic */
/** @jsx jsx */
import React, { ReactElement } from 'react';
import { ButtonIcon } from '../../atoms/icons/favoriteIcons';
import { jsx } from '@emotion/core';
import {
  ButtonContainer,
  CustomButton,
  IconContainer,
  ButtonWrap,
  DeclineFavoriteButton,
} from './FavoriteButtonStyles';
import StarFillIcon from '../icons/StarFillIcon';
import useMediaBreakpoints from '../../hooks/useMediaBreakpoints';

interface IFavoriteButton {
  favorited: boolean;
  page?: string;
  onClick: () => void;
}

const FavoriteButton = (props: IFavoriteButton): ReactElement => {
  const { favorited, ...rest } = props;
  const { isMobile, isDesktop } = useMediaBreakpoints();

  return (
    <ButtonContainer data-test-id="btn-container" aria-label={favorited ? 'Unfavorite' : 'Favorite'}>
      {favorited ? (
        <DeclineFavoriteButton
          data-test-id="remove-fav-btn"
          title="Remove from My Favorites"
          className="favorite-button"
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          isFavorited={favorited}
          {...rest}
          aria-label="Unfavorite"
        >
          <IconContainer>
            <StarFillIcon
              height={isMobile ? 28.21 : 38.21}
              width={isMobile ? 35 : 55}
              cssStyle={{
                height: isMobile && !isDesktop ? '25px' : '32px',
                width: '55px',
              }}
            />{' '}
          </IconContainer>
        </DeclineFavoriteButton>
      ) : (
        <CustomButton
          data-test-id="add-fav-btn"
          title="Add to My Favorite"
          className="favorite-button"
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          isFavorited={favorited}
          {...rest}
          aria-label="Favorite"
        >
          <IconContainer>
            <ButtonIcon fill={favorited ? '' : ''} />
          </IconContainer>
        </CustomButton>
      )}
      <label>{favorited ? 'Unfavorite' : 'Favorite'}</label>
    </ButtonContainer>
  );
};

export const HighlightFavoriteButton = (props: any): ReactElement => {
  const { favorited, ...rest } = props;
  // Todo: Where this style variable from?
  // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
  const favoriteButtonStyle = favorited ? { ...style.default, ...style.favorited } : style.default;

  return (
    <ButtonWrap customStyle={favoriteButtonStyle} {...rest}>
      <IconContainer>
        <ButtonIcon fill={favorited ? 'rgb(255, 255, 255)' : 'rgb(255, 175, 0)'} />
      </IconContainer>
    </ButtonWrap>
  );
};

FavoriteButton.defaultProps = {
  favorited: false,
};

export default FavoriteButton;
